module.exports = __webpack_public_path__ + "static/pg-def879a5b72abb15f99233b0f527a854.png";